// Routes that never render the signed-in workspace, so boot work for it is wasted there.
const NON_WORKSPACE_PATH =
  /^\/(?:auth|admin|share|ad|welcome|onboarding|request-access|landing|login|print|helpdesk|organizations)(?:\/|$)/i;

export function isNonWorkspacePath(pathname: string): boolean {
  return NON_WORKSPACE_PATH.test(pathname);
}
